import { Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import type { State } from '@core/jss-routing';
import { getLanguage, JssRouteBuilderService } from '@core/jss-routing';
import type { InnogyComponentRendering, JssRoute } from '@core/jss-models';
import { select, Store } from '@ngrx/store';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import {
  getActiveMainCategory,
  getBlogNodeMainCategories,
  getBlogNodeNavigationMain,
} from '../+state/blog.selector';
import type { JssBlogBase } from '../knowledge-base.model';

@Component({
  selector: 'wl-category-filter',
  templateUrl: './category-filter.component.html',
  styleUrls: [
    './category-filter.component.essent.scss',
    './category-filter.component.ed.scss',
  ],
  standalone: true,
  imports: [
    AutomationIdDirective,
    RouterLink,
    FormsModule,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class CategoryFilterComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  language$ = this.store$.pipe(select(getLanguage));
  main$ = this.store$.pipe(getBlogNodeNavigationMain);
  navItems$ = this.store$.pipe(
    getBlogNodeMainCategories,
    map((navItems) => (Array.isArray(navItems) ? navItems : []))
  );

  selected$ = combineLatest([
    this.store$.pipe(getActiveMainCategory),
    this.store$.pipe(getBlogNodeNavigationMain),
  ]).pipe(
    map(([mainCategory, main]) => {
      return mainCategory == null ? main : mainCategory;
    })
  );

  getRouteUrl(navItem: JssBlogBase, language: string) {
    const jssRoute: JssRoute = {
      language,
      serverRoute: navItem.url,
    };

    return this.urlBuilder.buildRouteUrl(jssRoute);
  }

  onChange(navItem: JssBlogBase, language: string) {
    this.router.navigateByUrl(this.getRouteUrl(navItem, language));
  }

  constructor(
    private readonly urlBuilder: JssRouteBuilderService,
    private readonly router: Router,
    private readonly store$: Store<State>,
    public translate: TranslateService
  ) {}
}
